<div class="paper-dialog">
  <h1 class="title">{{ 'NEW_CONTRACTS.PAPER_SIGNATURE' | i18nextEager }}</h1>
  <p class="text">{{ 'NEW_CONTRACTS.WANT_SEND_PAPER' | i18nextEager }}</p>
  <div class="buttons">
    <button class="secondary" (click)="onClose(false)">{{ 'COMMONS.CANCEL' | i18nextEager }}</button>
    <button class="primary" (click)="onClose(true)">{{ 'COMMONS.SEND' | i18nextEager }}</button>
  </div>
</div>
